import React from 'react';
import { PapiDeviation } from '@wix/da-types-papi';
import { WithTranslation, withTranslation } from 'react-i18next';
import StandardThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard';
import DeviationDumbView from '@wix/da-shared-react/pkg/DeviationViews/Dumbo';
import LoadableDuperbrowseContext from '../../../../../contexts/LoadableDuperbrowseContext';
import Grid, { GridElement } from '@wix/da-shared-react/pkg/Grid';
import { MeasuredCookieType } from '@wix/da-shared-react/pkg/Measured';

import PostEditableItem from '../../../../UserWidgets/_partials/PostEditableItem';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import { getDeviationEntityId } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';

export interface Props {
  streamId: string;
  items: PapiDeviation[];
  isDraft?: boolean;
}

export class PostsGrid extends React.Component<Props & WithTranslation> {
  render() {
    const { items, t, streamId } = this.props;
    return (
      <ErrorBoundary>
        <LoadableDuperbrowseContext
          streamId={streamId}
          parent={{ title: t('duperbrowse.backButton.profile.posts') }}
        >
          <Grid
            elementCount={items.length}
            cookieType={MeasuredCookieType.USER_PROFILE_POSTS}
            renderElement={this.renderElement}
            getElementId={this.getItemId}
            getDuperbrowseItemId={this.getDuperbrowseItemId}
            enableScrollOptim
          />
        </LoadableDuperbrowseContext>
      </ErrorBoundary>
    );
  }
  renderElement = (element: GridElement) => {
    const { items, isDraft } = this.props;
    const { width, height, index, style } = element;
    const item = items[index];

    return (
      <div key={index} style={style}>
        <PostEditableItem key={item.deviationId} isDraft={isDraft} item={item}>
          {isDraft ? (
            <DeviationDumbView
              key={item.deviationId}
              deviation={item}
              width={width}
              height={height}
            />
          ) : (
            <StandardThumb deviation={item} width={width} height={height} />
          )}
        </PostEditableItem>
      </div>
    );
  };

  getItemId = (index: number) => {
    const { items = [] } = this.props;
    const item = items[index];
    return `${index}-${item.deviationId}`;
  };

  getDuperbrowseItemId = (index: number) => {
    const { items = [] } = this.props;
    const item = items[index];
    return getDeviationEntityId(item);
  };
}

export default withTranslation()(PostsGrid);
